/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Release_Crumb_PublicInputs */

const en_newsletter_release_crumb_public = /** @type {(inputs: Newsletter_Release_Crumb_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue`)
};

/**
* | output |
* | --- |
* | "Issue" |
*
* @param {Newsletter_Release_Crumb_PublicInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_release_crumb_public = /** @type {((inputs?: Newsletter_Release_Crumb_PublicInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Release_Crumb_PublicInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_release_crumb_public(inputs)
});